import { render } from "./ListHuutonet.vue?vue&type=template&id=9b6becf6"
import script from "./ListHuutonet.vue?vue&type=script&lang=js"
export * from "./ListHuutonet.vue?vue&type=script&lang=js"

import "./ListHuutonet.vue?vue&type=style&index=0&id=9b6becf6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__